export const APPEARANCE_MIRROR_KEY = "kesherAppearanceMirror";

export function readAppearanceMirror() {
  try {
    const m = localStorage.getItem(APPEARANCE_MIRROR_KEY);
    if (m === "dark" || m === "light") return m;
  } catch {
    /* ignore */
  }
  return null;
}

export function writeAppearanceMirror(appearance) {
  try {
    localStorage.setItem(APPEARANCE_MIRROR_KEY, appearance);
  } catch {
    /* ignore */
  }
}

export function applyAppearanceToDom(appearance) {
  const mode = appearance === "dark" ? "dark" : "light";
  const root = document.getElementById("kesher-app");
  if (root) root.setAttribute("data-theme", mode);
  document.documentElement.setAttribute("data-theme", mode);
}
